import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'letrus-ui';
import useGoBackOrHome from 'containers/SimplifiedFeedback/useGoBackOrHome';
import styles from './SimplifiedFeedbackClosing.module.scss';

// TODO: real copy from Mari Parro not received yet — same directional-block pattern she added to
// the SAEB result screens (saeb-reading-result.tsx, Lovable prototype, commit "Adicionou bloco de
// próxima atividade"/"Atualizou mensagem da tela", 2026-09-21). Placeholder aligned to the same
// tone, pending validation — the real message changes depending on the student's actual next step
// in the ciclo (SAEB 2, or end of ciclo).
const CLOSING_MESSAGE = 'Em breve você receberá uma nova atividade!';
const CLOSING_EMOJI = '😊';

// Sits at the end of the page, after the text — so that when the essay is long, there's always a
// way to leave without having to scroll back to the top (found while testing with the user,
// 2026-09-22: the only exit button was in the header, out of view as soon as the text scrolled).
function SimplifiedFeedbackClosing(): JSX.Element {
  const goBackOrHome = useGoBackOrHome();

  return (
    <section className={styles.container}>
      <p className={styles.message}>
        {CLOSING_MESSAGE} <span aria-hidden="true">{CLOSING_EMOJI}</span>
      </p>

      {/* variant="secondary" (not "tertiary") — found by Raissa in review, 2026-09-24: tertiary
      reads as loose text, not as a real action. Same outline pattern as the "Voltar" in
      TrailCompleted. */}
      <Button
        variant="secondary"
        onClick={goBackOrHome}
        aria-label="Voltar para a home"
      >
        <FontAwesomeIcon icon={['fas', 'house']} />
        Voltar para a home
      </Button>
    </section>
  );
}

export default SimplifiedFeedbackClosing;
